/**
 * BuilderContext is for state that is:
 * 1) Only relevant to forms in the context of the builder
 * 2) Must be accessed by elements, settings, or styles.
 *
 * Currently, the only use case is `setActiveElement`, which must be called
 * from elements.
 */
import React, { useContext } from "react"

const BuilderContext = React.createContext({ setActiveElement: () => {} })

export const useBuilderState = () => {
  return useContext(BuilderContext)
}

export default BuilderContext
